import { useEffect } from 'react';

import {
  makeVar,
  useReactiveVar
} from '@apollo/client';
import { useMediaQuery } from '@mui/material';
import _ from 'lodash';



const __inPrintMode = makeVar<boolean>(false);

export function usePrint() {
  const inPrintMode = useReactiveVar(__inPrintMode);

  const printMode = useMediaQuery('print');

  useEffect(() => {
    const before = () => __inPrintMode(true);
    const after = () => __inPrintMode(false);
    window.addEventListener('beforeprint', before);
    window.addEventListener('afterprint', after);
    return () => {
      window.removeEventListener('beforeprint', before);
      window.removeEventListener('afterprint', after);
    };
  }, []);

  return {
    isInPrintMode: inPrintMode || printMode,
    print: () => {
      __inPrintMode(true);

      _.defer(() => {
        window.print();
      });
    }
  };
}
